import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { Edit, Visibility } from "@material-ui/icons";
import { navigate } from "@gatsbyjs/reach-router";
import ButtonIconTooltipCompleo from "Components/ButtonIconTooltipCompleo";
import useJobAccess from "customHooks/useAccess/useJobAccess";
import { JobApprovalStatus } from "Pages/Job/components/JobApprovalStatus";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        buttonRight: {
            marginLeft: "auto"
        }
    })
);

interface IProps {
    fieldData: Compleo.IObject;
    hideViewIcon?: boolean;
}

const OtherActions = (props: IProps) => {
    const { fieldData, hideViewIcon = false } = props;
    const jobStatus: CompleoShared.Common.JobStatus = fieldData.status;
    const jobApprovalStatus: CompleoShared.Common.JobStatus[] = [
        "jobApprovalApproved",
        "jobApprovalRejected",
        "jobApprovalInProgress",
        "jobApprovalRequested",
        "jobApprovalAwaitingCorrection",
        "jobApprovalExpired"
    ];
    const showJobApprovalIcon = jobApprovalStatus.includes(jobStatus);

    const classes = useStyles();
    const jobAccess = useJobAccess();
    const jobId = fieldData.pk.split(":")[1];

    const editJob = () => {
        navigate(`/job/edit/${jobId}`);
    };

    const viewJob = () => {
        navigate(`/job/view/${jobId}`);
    };

    return (
        <>
            <span className={classes.buttonRight} />
            {showJobApprovalIcon && (
                <JobApprovalStatus jobId={jobId} jobTitle={fieldData.title} />
            )}
            {!hideViewIcon && (
                <ButtonIconTooltipCompleo label="View" onClick={viewJob}>
                    <Visibility />
                </ButtonIconTooltipCompleo>
            )}
            {jobAccess.allowEdit && (
                <ButtonIconTooltipCompleo label="Edit" onClick={editJob}>
                    <Edit />
                </ButtonIconTooltipCompleo>
            )}
        </>
    );
};

export default OtherActions;
